/**
 * lib/availability.ts
 * ─────────────────────────────────────────────────────────────────────────────
 * Fungsi murni untuk menyelesaikan status ketersediaan (badge & orderable)
 * berdasarkan kombinasi game dan plan.
 * ─────────────────────────────────────────────────────────────────────────────
 */

export interface AvailabilityStatus {
  available: boolean;
  label: string;
  orderable: boolean;
}

export function resolveBadge(game: any, planSlug: string): AvailabilityStatus {
  if (!game) {
    return { available: false, label: 'Belum tersedia', orderable: false };
  }

  // Truth guard: jika game status coming_soon, tidak bisa di-order
  if (game.status === 'coming_soon') {
    return { available: false, label: 'Coming soon', orderable: false };
  }

  // Cari status ketersediaan plan khusus game ini
  const planAvail = game.availability?.find((a: any) => a.plan_slug === planSlug);
  if (!planAvail) {
    return { available: false, label: 'Belum tersedia', orderable: false };
  }

  if (planAvail.available) {
    return { available: true, label: 'Tersedia', orderable: true };
  }

  // Map reason ke label UX yang ramah
  switch (planAvail.reason) {
    case 'coming_soon':
      return { available: false, label: 'Coming soon', orderable: false };
    case 'no_capacity':
      return { available: false, label: 'Stok habis', orderable: false };
    case 'plan_too_small':
      return { available: false, label: 'Plan terlalu kecil', orderable: false };
    default:
      return { available: false, label: 'Belum tersedia', orderable: false };
  }
}
